import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../../../models/hooks/appStateHooks';
import { AUTOMATION_TEMPLATE_MUTATION_KEY } from '../../queryKeys';

interface Params {
	templateId: string;
	stepIds: string[];
	impersonationContext?: Api.IImpersonationContext;
}

export function useAutomationTemplateReorderStepsMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: (data: string[], variables: Params) => void;
	onError?: (error: Api.IOperationResultNoValue, variables: Params) => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationKey: AUTOMATION_TEMPLATE_MUTATION_KEY,
		mutationFn: ({ templateId, stepIds, impersonationContext }: Params) => {
			return userSession.webServiceHelper.callAsync<string[]>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `AutomationTemplate/${encodeURIComponent(templateId)}/stepOrder`,
					impersonationContext,
				}),
				'PUT',
				stepIds
			);
		},
		onError,
		onSuccess,
	});
}
